/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("id", {
  Redo: "Ulang",
  Undo: "Batalkan",
  Cut: "Potong",
  Copy: "Salin",
  Paste: "Rekat",
  "Select all": "Pilih semua",
  "New document": "Dokumen baru",
  Ok: "Ok",
  Cancel: "Batal",
  "Visual aids": "Alat bantu visual",
  Bold: "Tebal",
  Italic: "Miring",
  Underline: "Garis bawah",
  Strikethrough: "Coret",
  Superscript: "Superskrip",
  Subscript: "Subskrip",
  "Clear formatting": "Kosongkan format",
  "Align left": "Rata kiri",
  "Align center": "Rata tengah",
  "Align right": "Rata kanan",
  Justify: "Rata penuh",
  "Bullet list": "Daftar bersimbol",
  "Numbered list": "Daftar bernomor",
  "Decrease indent": "Kurangi inden",
  "Increase indent": "Tambah inden",
  Close: "Tutup",
  Formats: "Format",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Browser anda tidak mendukung akses langsung ke papan klip. Silakan gunakan pintasan Ctrl+X/C/V dari keyboard.",
  Headers: "Judul",
  "Header 1": "Judul 1",
  "Header 2": "Judul 2",
  "Header 3": "Judul 3",
  "Header 4": "Judul 4",
  "Header 5": "Judul 5",
  "Header 6": "Judul 6",
  Headings: "Kepala",
  "Heading 1": "Kepala 1",
  "Heading 2": "Kepala 2",
  "Heading 3": "Kepala 3",
  "Heading 4": "Kepala 4",
  "Heading 5": "Kepala 5",
  "Heading 6": "Kepala 6",
  Preformatted: "Praformat",
  Div: "Div",
  Pre: "Pre",
  Code: "Kode",
  Paragraph: "Paragraf",
  Blockquote: "Kutipan",
  Inline: "Baris",
  Blocks: "Blok",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Penempelan sekarang dalam modus teks biasa. Konten sekarang akan disisipkan sebagai teks biasa sampai Anda memadamkan pilihan ini.",
  Fonts: "Huruf",
  "Font Sizes": "Ukuran Huruf",
  Class: "Kelas",
  "Browse for an image": "Jelajahi gambar",
  OR: "ATAU",
  "Drop an image here": "Simpan gambar di sini",
  Upload: "Unggah",
  Block: "Blok",
  Align: "Sejajarkan",
  Default: "Bawaan",
  Circle: "Lingkaran",
  Disc: "Cakram",
  Square: "Kotak",
  "Lower Alpha": "Huruf Kecil",
  "Lower Greek": "Huruf Kecil Yunani",
  "Lower Roman": "Huruf Kecil Romawi",
  "Upper Alpha": "Huruf Besar",
  "Upper Roman": "Huruf Besar Romawi",
  "Anchor...": "Jangkar..",
  Name: "Nama",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Id harus dimulai dengan huruf, dan hanya diikuti oleh huruf, angka, koma, titik, titik koma atau garis bawah.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Anda memiliki perubahan yang belum disimpan, yakin ingin beralih ?",
  "Restore last draft": "Muat kembali draft sebelumnya",
  "Special character...": "Karakter khusus...",
  "Source code": "Kode sumber",
  "Insert/Edit code sample": "Tambah/Edit contoh kode",
  Language: "Bahasa",
  "Code sample...": "Sampel kode...",
  "Color Picker": "Pemilih warna",
  R: "M",
  G: "H",
  B: "B",
  "Left to right": "Kiri ke kanan",
  "Right to left": "Kanan ke kiri",
  "Emoticons...": "Emotikon...",
  "Metadata and Document Properties": "Metadata dan Properti Dokumen",
  Title: "Judul",
  Keywords: "Kata kunci",
  Description: "Deskripsi",
  Robots: "Robot",
  Author: "Penulis",
  Encoding: "Enkoding",
  Fullscreen: "Layar penuh",
  Action: "Tindakan",
  Shortcut: "Pintasan",
  Help: "Bantuan",
  Address: "Alamat",
  "Focus to menubar": "Fokus ke menubar",
  "Focus to toolbar": "Fokus ke toolbar",
  "Focus to element path": "Fokus ke jalur elemen",
  "Focus to contextual toolbar": "Fokus ke toolbar kontekstual",
  "Insert link (if link plugin activated)":
    "Masukan link (jika plugin diaktifkan)",
  "Save (if save plugin activated)": "Simpan (jika plugin simpan diaktifkan)",
  "Find (if searchreplace plugin activated)":
    "Cari (jika plugin searchplace diaktifkan)",
  "Plugins installed ({0}):": "Plugin terpasang ({0})",
  "Premium plugins:": "Plugin premium:",
  "Learn more...": "Pelajari selengkapnya...",
  "You are using {0}": "Anda menggunakan {0}",
  Plugins: "Plugin",
  "Handy Shortcuts": "Pintasan Praktis",
  "Horizontal line": "Garis horisontal",
  "Insert/edit image": "Sisip/sunting gambar",
  "Image description": "Deskripsi gambar",
  Source: "Sumber",
  Dimensions: "Dimensi",
  "Constrain proportions": "Samakan proporsi",
  General: "Umum",
  Advanced: "Lanjutan",
  Style: "Gaya",
  "Vertical space": "Spasi vertikal",
  "Horizontal space": "Spasi horisontal",
  Border: "Batas",
  "Insert image": "Sisipkan gambar",
  "Image...": "Gambar...",
  "Image list": "Daftar gambar",
  "Rotate counterclockwise": "Putar berlawananjarumjam",
  "Rotate clockwise": "Putar searahjarumjam",
  "Flip vertically": "Balik vertikal",
  "Flip horizontally": "Balik horisontal",
  "Edit image": "Sunting gambar",
  "Image options": "Opsi gambar",
  "Zoom in": "Perbesar",
  "Zoom out": "Perkecil",
  Crop: "Krop",
  Resize: "Ubah ukuran",
  Orientation: "Orientasi",
  Brightness: "Kecerahan",
  Sharpen: "Ketajaman",
  Contrast: "Kontras",
  "Color levels": "Tingakt warna",
  Gamma: "Gamma",
  Invert: "Kebalikan",
  Apply: "Terapkan",
  Back: "Kembali",
  "Insert date/time": "Sisipkan tanggal/waktu",
  "Date/time": "Tanggal/waktu",
  "Insert/Edit Link": "Masukkan/Edit Tautan",
  "Insert/edit link": "Sisip/sunting tautan",
  "Text to display": "Teks yang ditampilkan",
  Url: "Tautan",
  "Open link in...": "Buka tautan dalam...",
  "Current window": "Jendela saat ini",
  None: "Tidak ada",
  "New window": "Jendela baru",
  "Remove link": "Buang tautan",
  Anchors: "Jangkar",
  "Link...": "Tautan...",
  "Paste or type a link": "Tempel atau ketik sebuah tautan",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "Tautan yang anda masukkan sepertinya adalah alamat email. Apakah Anda ingin menambahkan prefiks mailto: yang dibutuhkan?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "Tautan yang anda masukkan sepertinya adalah tautan eksternal. Apakah Anda ingin menambahkan prefiks http:// yang dibutuhkan?",
  "Link list": "Daftar tautan",
  "Insert video": "Sisipkan video",
  "Insert/edit video": "Sisip/sunting video",
  "Insert/edit media": "Sisip/sunting media",
  "Alternative source": "Sumber alternatif",
  "Alternative source URL": "URL Sumber alternatif",
  "Media poster (Image URL)": "Poster media (URL gambar)",
  "Paste your embed code below:": "Tempel kode yang diembed dibawah ini:",
  Embed: "Embed",
  "Media...": "Media...",
  "Nonbreaking space": "Spasi",
  "Page break": "Baris baru",
  "Paste as text": "Tempel sebagai teks biasa",
  Preview: "Pratinjau",
  "Print...": "Cetak...",
  Save: "Simpan",
  Find: "Cari",
  "Replace with": "Ganti dengan",
  Replace: "Ganti",
  "Replace all": "Ganti semua",
  Previous: "Sebelumnya",
  Next: "Berikutnya",
  "Find and replace...": "Cari dan ganti...",
  "Could not find the specified string.":
    "Tidak dapat menemukan string yang dimaksud.",
  "Match case": "Samakan besar kecil huruf",
  "Find whole words only": "Cari hanya kata utuh",
  "Spell check": "Periksa ejaan",
  Ignore: "Abaikan",
  "Ignore all": "Abaikan semua",
  Finish: "Selesai",
  "Add to Dictionary": "Tambahkan ke kamus",
  "Insert table": "Sisipkan tabel",
  "Table properties": "Properti tabel",
  "Delete table": "Hapus tabel",
  Cell: "Sel",
  Row: "Baris",
  Column: "Kolom",
  "Cell properties": "Properti sel",
  "Merge cells": "Gabung sel",
  "Split cell": "Bagi sel",
  "Insert row before": "Sisipkan baris sebelum",
  "Insert row after": "Sisipkan baris setelah",
  "Delete row": "Hapus baris",
  "Row properties": "Properti baris",
  "Cut row": "Penggal baris",
  "Copy row": "Salin baris",
  "Paste row before": "Tempel baris sebelum",
  "Paste row after": "Tempel baris setelah",
  "Insert column before": "Sisipkan kolom sebelum",
  "Insert column after": "Sisipkan kolom setelah",
  "Delete column": "Hapus kolom",
  Cols: "Kolom",
  Rows: "Baris",
  Width: "Lebar",
  Height: "Tinggi",
  "Cell spacing": "Spasi sel ",
  "Cell padding": "Lapisan sel",
  "Show caption": "Perlihatkan keterangan",
  Left: "Kiri",
  Center: "Tengah",
  Right: "Kanan",
  "Cell type": "Tipe sel",
  Scope: "Skup",
  Alignment: "Penjajaran",
  "H Align": "Rata Samping",
  "V Align": "Rata Atas",
  Top: "Atas",
  Middle: "Tengah",
  Bottom: "Bawah",
  "Header cell": "Judul sel",
  "Row group": "Kelompok baris",
  "Column group": "Kelompok kolom",
  "Row type": "Tipe baris",
  Header: "Judul",
  Body: "Body",
  Footer: "Footer",
  "Border color": "Warna batas",
  "Insert template...": "Masukkan template...",
  Templates: "Templat",
  Template: "Templat",
  "Text color": "Warna teks",
  "Background color": "Warna latar",
  "Custom...": "Atur sendiri...",
  "Custom color": "Warna sendiri",
  "No color": "Tidak berwarna",
  "Remove color": "Hapus warna",
  "Table of Contents": "Daftar Isi",
  "Show blocks": "Tampilkan blok",
  "Show invisible characters": "Tampilkan karakter tak tampak",
  "Word count": "Hitungan kata",
  Count: "Hitungan",
  Document: "Dokumen",
  Selection: "Pemilihan",
  Words: "Kata",
  "Words: {0}": "Kata: {0}",
  "{0} words": "{0} kata",
  File: "Berkas",
  Edit: "Sunting",
  Insert: "Sisip",
  View: "Tampilan",
  Format: "Format",
  Table: "Tabel",
  Tools: "Alat",
  "Powered by {0}": "Didukung oleh {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Area teks kaya. Tekan ALT-F9 untuk menu. Tekan ALT-F10 untuk toolbar. Tekan ALT-0 untuk bantuan",
  "Image title": "Judul gambar",
  "Border width": "Lebar pinggiran",
  "Border style": "Gaya pinggiran",
  Error: "Kesalahan",
  Warn: "Peringatkan",
  Valid: "Valid",
  "To open the popup, press Shift+Enter":
    "Untuk membuka popup, tekan Shift+Enter",
  "Rich Text Area. Press ALT-0 for help.":
    "Area Teks Kaya. Tekan ALT-0 untuk bantuan.",
  "System Font": "Huruf Sistem",
  "Failed to upload image: {0}": "Gagal mengunggah gambar: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Gagal memuat plugin: {0} dari url {1}",
  "Failed to load plugin url: {0}": "Gagal memuat url plugin: {0}",
  "Failed to initialize plugin: {0}": "Gagal memulai plugin: {0}",
  example: "contoh",
  Search: "Cari",
  All: "Semua",
  Currency: "Mata Uang",
  Text: "Teks",
  Quotations: "Kutipan",
  Mathematical: "Matematis",
  "Extended Latin": "Latin Diperluas",
  Symbols: "Simbol",
  Arrows: "Panah",
  "User Defined": "Ditentukan Pengguna",
  "dollar sign": "tanda dolar",
  "currency sign": "tanda mata uang",
  "euro-currency sign": "tanda mata uang eropa",
  "colon sign": "tanda titik dua",
  "cruzeiro sign": "tanda cruzeiro",
  "french franc sign": "tanda franc prancis",
  "lira sign": "tanda lira",
  "mill sign": "tanda mill",
  "naira sign": "tanda naira",
  "peseta sign": "tanda peseta",
  "rupee sign": "tanda rupee",
  "won sign": "tanda won",
  "new sheqel sign": "tanda sheqel baru",
  "dong sign": "tanda dong",
  "kip sign": "tanda kip",
  "tugrik sign": "tanda tugrik",
  "drachma sign": "tanda drachma",
  "german penny symbol": "simbol penny jerman",
  "peso sign": "tanda peso",
  "guarani sign": "tanda guarani",
  "austral sign": "tanda austral",
  "hryvnia sign": "tanda hryvnia",
  "cedi sign": "tanda cedi",
  "livre tournois sign": "tanda livre tournois",
  "spesmilo sign": "tanda spesmilo",
  "tenge sign": "tanda tenge",
  "indian rupee sign": "tanda rupee india",
  "turkish lira sign": "tanda lira turki",
  "nordic mark sign": "tanda mark nordik",
  "manat sign": "tanda manat",
  "ruble sign": "tanda ruble",
  "yen character": "karakter yen",
  "yuan character": "karakter yuan",
  "yuan character, in hong kong and taiwan":
    "karakter yuan, di hong kong dan taiwan",
  "yen/yuan character variant one": "varian satu karakter yen/yuan",
  "Loading emoticons...": "Memuat emotikon...",
  "Could not load emoticons": "Tidak dapat memuat emotikon",
  People: "Orang",
  "Animals and Nature": "Hewan dan Alam",
  "Food and Drink": "Makanan dan Minuman",
  Activity: "Aktivitas",
  "Travel and Places": "Perjalanan dan Lokasi",
  Objects: "Objek",
  Flags: "Bendera",
  Characters: "Karakter",
  "Characters (no spaces)": "Karakter (tanpa spasi)",
  "{0} characters": "{0} karakter",
  "Error: Form submit field collision.":
    "Kesalahan: Benturan bidang pengiriman bentuk.",
  "Error: No form element found.": "Kesalahan: tidak ditemukan elemen bentuk.",
  Update: "Perbarui",
  "Color swatch": "Contoh warna",
  Turquoise: "Turquoise",
  Green: "Hijau",
  Blue: "Biru",
  Purple: "Ungu",
  "Navy Blue": "Biru Navy",
  "Dark Turquoise": "Turquoise Gelap",
  "Dark Green": "Hijau Gelap",
  "Medium Blue": "Biru Medium",
  "Medium Purple": "Ungu Medium",
  "Midnight Blue": "Biru Midnight",
  Yellow: "Kuning",
  Orange: "Jingga",
  Red: "Merah",
  "Light Gray": "Abu Muda",
  Gray: "Abu-abu",
  "Dark Yellow": "Kuning Gelap",
  "Dark Orange": "Jingga Gelap",
  "Dark Red": "Merah Gelap",
  "Medium Gray": "Abu Medium",
  "Dark Gray": "Abu Gelap",
  "Light Green": "Hijau Muda",
  "Light Yellow": "Kuning Muda",
  "Light Red": "Merah Muda",
  "Light Purple": "Ungu Muda",
  "Light Blue": "Biru Muda",
  "Dark Purple": "Ungu Gelap",
  "Dark Blue": "Biru Gelap",
  Black: "Hitam",
  White: "Putih",
  "Switch to or from fullscreen mode": "Alihkan ke atau dari mode layar penuh",
  "Open help dialog": "Buka dialog bantuan",
  history: "riwayat",
  styles: "gaya",
  formatting: "pemformatan",
  alignment: "penyejajaran",
  indentation: "indentasi",
  "permanent pen": "pena permanen",
  comments: "komentar",
  "Format Painter": "Format Pelukis",
  "Insert/edit iframe": "Masukkan/edit iframe",
  Capitalization: "Kapitalisasi",
  lowercase: "huruf kecil",
  UPPERCASE: "HURUF BESAR",
  "Title Case": "Huruf Judul",
  "Permanent Pen Properties": "Properti Pena Permanen",
  "Permanent pen properties...": "Properti pena permanen...",
  Font: "Huruf",
  Size: "Ukuran",
  "More...": "Lainnya...",
  "Spellcheck Language": "Periksa Ejaan Bahasa",
  "Select...": "Pilih...",
  Preferences: "Preferensi",
  Yes: "Ya",
  No: "Tidak",
  "Keyboard Navigation": "Navigasi Keyboard",
  Version: "Versi",
  Anchor: "Jangkar",
  "Special character": "Spesial karakter",
  "Code sample": "Contoh kode",
  Color: "Warna",
  Emoticons: "Emotikon",
  "Document properties": "Properti dokumwn",
  Image: "Gambar",
  "Insert link": "Sisipkan tautan",
  Target: "Jendela tujuan",
  Link: "Tautan",
  Poster: "Penulis",
  Media: "Media",
  Print: "Cetak",
  Prev: "Sebelumnya",
  "Find and replace": "Cari dan ganti",
  "Whole words": "Semua kata",
  Spellcheck: "Periksa ejaan",
  Caption: "Caption",
  "Insert template": "Sisipkan templat",
});
